<template>
	<div class="c-quick-links c-quick-links--features">
		<section class="c-quick-links__content">
			<quick-link-content-item
				v-for="item in vm.BaseViewModel.ContentFeatureItems"
				:key="item.Headline"
				:item="item"
				/>
		</section>
	</div>
</template>

<script>
	import QuickLinkContentItem from 'Features/QuickLinks/Views/quickLinkContentItem.vue';

	export default {
		name: 'content-feature-items',
		components: {
			QuickLinkContentItem,
		},
		props: {
			vm: {
				type: Object,
				required: true,
			},
		}
	}
</script>
